export enum CurrentFilterEnum {
  Time = 'time',
  Supplement = 'supplement',
}

export enum ClientsCurrentFilterEnum {
  Chronology = 'chronology',
  Accruals = 'accruals',
}
